var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Stickers"},_vm._l((_vm.stickers),function(sticker,i){return _c('div',{ref:'sticker_'+ i,refInFor:true,staticClass:"Stickers__el"},[_c('img',{attrs:{"src":require('./stickers/'+ sticker +'.png')}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3be20d59","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/Stickers.vue
// module id = null
// module chunks = 